import axios, { buildApi } from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取关键词类型

export const apis = buildApi({
  get: ['/common/customer'],
})

export const getKeysType = (type) => {
  let params = {
    keywordsType: type,
  };
  return axios.request({
    url: "/share/getKeywordsType",
    method: "get",
    params,
  });
};

// 获取下拉数据
export const getSelectType = (type) => {
  let data = {
    selectType: type,
  };
  return axios.request({
    url: "/share/getSelectType",
    method: "post",
    data,
  });
};

// 获取代理类型
export const getSelAgent = (params) => {
  return axios.request({
    url: "/common/agentType",
    method: "get",
    params,
  });
};

// 获取用户部门列表
export const getUserDepart = () => {
  return axios.request({
    url: "/common/firstLevel",
    method: "get",
  });
};

// 获取内部用户列表
export const getUserList = (params) => {
  return axios.request({
    url: "/common/staff",
    method: "get",
    params,
  });
};

// 上传图片
export const uploadImg = (data) => {
  return axios.request({
    url: "/common/notice/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};

// 获取群聊名称
export const getGroupName = (params) => {
  return axios.request({
    url: `/common/groupName`,
    method: "get",
    params,
  });
};

// 获取结算周期
export const billingCycle = (params) => {
  return axios.request({
    url: `/common/billing_cycle`,
    method: "get",
    params,
  });
};

export const getCurrency = () => {
  return axios.request({
    url: `/common/currency`,
    method: "get",
  });
};

export const delivery_service = () => {
  return axios.request({
    url: `/common/delivery_service`,
    method: "get",
  });
};

export const home = () => {
  return axios.request({
    url: `/home`,
    method: "get",
  });
};

export const upload = (data) => {
  return axios.request({
    url: "/common/upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
  });
};

export const getCustomer = (params) => {
  return axios.request({
    url: `/common/customer`,
    method: "get",
    params,
  });
};

export const getOwnership = (params) => {
  return axios.request({
    url: `/common/ownership`,
    method: "get",
    params,
  });
};

export const getPayType = () => {
  return axios.request({
    url: `/common/payType`,
    method: "get",
  });
};

export const getDuration = () => {
  return axios.request({
    url: `/common/duration_time`,
    method: "get",
  });
};


export const inputHistory = (type) => {
  return axios.request({
    url: `/common/inputHistory/` + type,
    method: "get",
  });
};

export const platformType = () => {
  return axios.request({
    url: `/common/platformType`,
    method: "get",
  });
};

export const province = (params) => {
  return axios.request({
    url: `/common/province`,
    method: "get",
    params
  });
};

export const warehouseSelect = (params) => {
  return axios.request({
    url: `/common/warehouseSelect`,
    method: "get",
    params
  });
};

export const getTransportCode = () => {
  return axios.request({
    url: `/common/method`,
    method: "get",
  });
}
